import * as React from 'react'
import dynamic from 'next/dynamic'

import {LazyLoad} from '@lib/LazyLoad'
import {IconArrowDown, IconArrowRight} from '@components/Icon'
import ImgSet from '@components/demo/ImgSet'

const MainLayout = dynamic(() => import('@components/MainLayout'))
const GetStarted = dynamic(() => import('@components/GetStarted'))
const Meta = dynamic(() => import('@components/Meta'))

const Demo = () => {
  const demos = [
    {
      img: '/images/demo/ocr.jpg',
      title: 'OCR',
      description:
        'บริการแปลงรูปภาพอักษรบนบัตรเป็นข้อความด้วย AI คุณภาพ เพียงสแกนข้อมูลบนบัตรประชาชน หนังสือเดินทาง หรือใบขับขี่ ระบบจะแปลงรูปภาพดังกล่าวออกมาเป็นข้อความ ช่วยให้คุณได้ลดเวลาในการกรอกข้อมูลทีละตัวอักษร และเพิ่มความแม่นยำในการทำงานมากยิ่งขึ้น ',
      href: '/demo/ocr',
    },
    {
      img: '/images/demo/demographic.jpg',
      title: 'Demographic',
      description:
        'บริการตรวจจับ เพศ อายุ และเชื้อชาติของบุคคลด้วยโมเดล AI โดยการนำ FaceNet Model มาปรับปรุงด้วย Data Set ภาพบุคคลในช่วงอายุต่าง ๆ เพื่อพัฒนาให้โมเดลมีความแม่นยำและครอบคลุมความแปรผันของแต่ละปัจจัย',
      href: '/demo/demographic',
    },
    {
      img: '/images/demo/object-detection.jpg',
      title: 'Object Detection and Image Classifier API',
      description:
        'บริการระบุประเภทข้อมูลและวิเคราะห์วัตถุในรูปภาพหรือวิดีโอ (Data Labeling) เพื่อให้ง่ายต่อการจัดการและลดระยะเวลาในการจำแนกข้อมูล ระบบของเราจะเพิ่มประสิทธิภาพในการทำงานอย่างครบวงจร โดยเฉพาะกับงานที่ซับซ้อนและมีข้อมูลจำนวนมาก',
      href: '/demo/detection',
    },
  ]

  return (
    <React.Fragment>
      <Meta
        title='บริการ AI Solution พัฒนาและให้คำปรึกษาสำหรับทุกธุรกิจ'
        description='ปลดล็อคศักยภาพและเพิ่มขีดจำกัดของธุรกิจและองค์กรของคุณด้วย AI Solution ที่มีคุณภาพ Data Wowo บริการให้คำปรึกษาและพัฒนาโมเดล AI แบบครบวงจร เพื่อธุรกิจ'
      />
      <MainLayout>
        <div className='Demo'>
          <div className='Demo__hero'>
            <div className='container'>
              <div className='Demo__hero__body'>
                <h1>
                  AI Solution <br/>
                  บริการให้คำปรึกษาและพัฒนา <span>AI</span>
                </h1>

                <p className='Demo__p'>
                  ปลดล็อคศักยภาพและเพิ่มขีดความสามารถของธุรกิจคุณด้วยโมเดล AI
                  คุณภาพ หากคุณกำลังมองหาบริการด้าน AI
                  เพื่อนำไปปรับใช้ในองค์กรและอุตสาหกรรมของคุณได้อย่างเหมาะสมกับความต้องการ
                  เราเปิดพื้นที่ให้คุณได้สามารถทดลอง AI
                  ของเราได้โดยไม่เสียค่าใช้จ่ายใด ๆ
                </p>

                <a
                  href='#ai'
                  onClick={(event) => {
                    const {hash} = event.currentTarget
                    event.preventDefault()

                    window.history.pushState(null, null, hash)
                    document
                      .querySelector(hash)
                      .scrollIntoView({behavior: 'smooth'})
                  }}
                >
                  <IconArrowDown />
                </a>
              </div>
            </div>

            <div className='Demo__hero__space'></div>

            <ImgSet
              src='/images/demo/hero.jpg'
              alt='AI'
              className='Demo__hero__img'
            />
          </div>

          <div className='Demo__content' id='ai'>
            <div className='container'>
              <h2>
                <span>ทดลอง AI Solution</span>
                ช่วยให้การทำงานของคุณสะดวกมากยิ่งขึ้น
              </h2>
              <p className='Demo__p'>
                Data Wow เปิดพื้นที่ให้คุณได้ทดลองระบบฟรี ซึ่งตัว AI API
                ของเราเป็นบริการที่จะช่วยให้นักพัฒนาสามารถวิเคราะห์ภาพตามต้องการได้
                ไม่ว่าจะเป็นบริการยืนยันตัวตน (e-KYC) บริการตรวจจับ Demographic
                ของบุคคลในภาพ บริการแปลงรูปภาพอักษรเป็นข้อความ หรือ
                บริการระบุประเภทข้อมูลวิเคราะห์วัตถุในรูปภาพหรือวิดีโอ เป็นต้น
                ทั้งนี้คุณจะได้เห็นผลลัพท์แบบ Real-time
                ที่คุณสามารถนำบริการของเราไปต่อยอดกับธุรกิจของคุณได้
              </p>

              <ul className='Demo__list'>
                {demos.map((demo, index) => (
                  <DemoItem {...demo} key={index} />
                ))}
              </ul>
            </div>
          </div>
        </div>

        <LazyLoad>
          <GetStarted />
        </LazyLoad>
      </MainLayout>
    </React.Fragment>
  )
}

const DemoItem = ({img, title, description, href}) => {
  return (
    <li className='Demo__item'>
      <div className='Demo__item__body'>
        <ImgSet
          src={img}
          alt={title}
          className='Demo__item__img'
          loading='lazy'
        />
        <div>
          <h3 className='Demo__item__title'>{title}</h3>
          <p className='Demo__item__description'>{description}</p>
        </div>
      </div>

      <a
        href={href}
        className='Demo__item__link'
        rel='noopener noreferrer'
        target='_blank'
      >
        <ImgSet
          src={img}
          alt={title}
          className='Demo__item__link__img'
          loading='lazy'
        />
        <span>ทดลองเล่น</span>
        <IconArrowRight />
      </a>
    </li>
  )
}

export default Demo
